import { Client, PartEvent } from 'irc-framework';
import { IRC_EVENT, IRCMessageType, tabType } from '#/types/types';
import ConnectionHandler from '#/connectionHandler';
import TabManager from '#/ui/tabManager';
import MessageHandler from '#/messageHandler';

export class PartEventListener {
    private cH: ConnectionHandler;
    private client: Client;
    private tM: TabManager;
    private mH: MessageHandler;

    constructor(connectionHandler: ConnectionHandler) {
        this.cH = connectionHandler as ConnectionHandler;
        this.client = connectionHandler.client as Client;
        this.tM = connectionHandler.tabManager as TabManager;
        this.mH = connectionHandler.messageHandler as MessageHandler;
        this.setup();
    }

    private setup(): void {
        this.client.on(IRC_EVENT.PART, (event: PartEvent) => {
            const { nick, ident, hostname, channel, message, time, account, tags, batch } = event;
            const ourNick = this.client?.user.nick;
            const isOwnPart = nick === ourNick;

            if (isOwnPart) {
                this.tM.closeTab(channel);
                this.mH.addMessage(this.tM.getStatusTab(), `* You have left ${channel} (${message || 'Leaving'})`, IRCMessageType.SYSTEM);
            } else {
                const channelTab = this.tM.getTab(tabType.CHANNEL, channel);
                if (channelTab) {
                    this.mH.addMessage(channelTab, `* ${nick} has left ${channel} (${message || 'Leaving'})`, IRCMessageType.SYSTEM);
                }
                this.cH.refreshUserList(channel);
            }
        });
    }
}
